import React from 'react'
import Area from 'site/Renderer/components/Area/Area'
import Article from 'site/Renderer/components/ArticleContainer/ArticleContainer'
import Authentication from 'site/Renderer/components/Authentication'
import CardCarousel from 'site/Renderer/components/CardCarousel'
import Cards from 'site/Renderer/components/CardContainer/CardContainer'
import Cockpit from 'site/Renderer/components/Cockpit/Cockpit'
import DataCards from 'site/Renderer/components/DataCards/DataCards'
import DataTables from 'site/Renderer/components/DataTables/DataTables'
import DynamicInfoCardHighlight from 'site/Renderer/components/DynamicInfoCardHighlightContainer/DynamicInfoCardHighlightContainer'
import DynamicTextHighlight from 'site/Renderer/components/DynamicTextHighlightContainer/DynamicTextHighlightContainer'
import FilterFields from 'site/Renderer/components/FilterFields/FilterFields'
import HeroBanner from 'site/Renderer/components/HeroBannerContainer/HeroBannerContainer'
import HeroBannerSecondary from 'site/Renderer/components/HeroBannerSecondaryContainer/HeroBannerSecondaryContainer'
import Kanban from 'site/Renderer/components/Kanban'
import DataMap from 'site/Renderer/components/MapContainer/MapContainer'
import NavigationSliderSecondary from 'site/Renderer/components/NavigationSliderSecondaryContainer/NavigationSliderSecondaryContainer'
import ObjectView from 'site/Renderer/components/ObjectView/ObjectView'
import SiteFooter from 'site/Renderer/components/SiteFooterContainer/SiteFooterContainer'
import SupportBanner from 'site/Renderer/components/SupportBannerContainer'
import TaskExecutor from 'site/Renderer/components/TaskExecutor'
import TopLine from 'site/Renderer/components/TopLine'
import Workflowmodel from 'site/Renderer/components/WorkflowmodelContainer/WorkflowmodelContainer'
import Separator from '../Separator/Separator'
import AccessRestriction from './AccessRestrictionContainer/AccessRestriction'
import Accordion from './Accordion'
import ActionSteps from './ActionSteps'
import AnimationSlider from './AnimationSliderContainer/AnimationSliderContainer'
import ArticlesList from './ArticlesListContainer/ArticlesListContainer'
import Divider from './Divider/Divider'
import DynamicInfoCardHighlightSimplified from './DynamicInfoCardHighlightSimplifiedContainer'
import ElementRenderer from './ElementRenderer'
import EventCard from './EventCardContainer/EventCardContainer'
import FilterableMap from './FilterableMap/FilterableMap'
import { Col, Grid, Row } from './Grid/Grid'
import Metadata from './Metadata'
import ContextualNavigationSlider from './NavigationSlider/Contextual/ContextualNavigationSlider'
import NumericCardList from './NumericCardList/NumericCardList'
import PartnerCard from './PartnerCardContainer/PartnerCardContainer'
import SummaryDetailsCarousel from './SummaryDetailsCarouselContainer/SummaryDetailsCarouselContainer'
import SupportBannerSecondary from './SupportBannerSecondaryContainer'
import TabsContent from './TabsContent/TabsContent'
import TextExpression from './TextExpressionContainer/TextExpressionContainer'
import TextSlider from './TextSlider/TextSlider'
import Unauthorized from './UnauthorizedContainer/UnauthorizedContainer'
import Video from './Video/Video'

import { ComponentTypeGuard } from '../wrappers/TypeGuard/TypeGuard.types'
import { AccordionTypeGuard } from './Accordion/Accordion.types'
import ActionButton from './ActionButton/ActionButton'
import { ActionButtonTypeGuard } from './ActionButton/ActionButton.types'
import { ActionStepsTypeGuard } from './ActionSteps/types'
import { AnimationSliderContainerTypeGuard } from './AnimationSliderContainer/AnimationSlider.types'
import { ArticleContainerTypeGuard } from './ArticleContainer/ArticleContainer.types'
import { AuthenticationTypeGuard } from './Authentication/Authentication.types'
import { CardContainerTypeGuard } from './CardContainer/CardContainer.types'
import { DataCardsTypeGuard } from './DataCards/DataCards.types'
import { DataTablesTypeGuard } from './DataTables/types/guard'
import { DividerTypeGuard } from './Divider/Divider.types'
import { DynamicTextHighlightContainerTypeGuard } from './DynamicTextHighlightContainer/DynamicTextHighlightContainer.types'
import { FilterFieldsTypeGuard } from './FilterFields/types/guard'
import { HeroBannerContainerTypeGuard } from './HeroBannerContainer/HeroBannerContainer.types'
import { HeroBannerSecondaryContainerTypeGuard } from './HeroBannerSecondaryContainer/HeroBannerSecondaryContainer.types'
import { KanbanTypeGuard } from './Kanban/Kanban.types'
import { NavigationSliderSecondaryContainerTypeGuard } from './NavigationSliderSecondaryContainer/NavigationSliderSecondaryContainer.types'
import { NumericCardListTypeGuard } from './NumericCardList/NumericCardList.types'
import Processmodel from './ProcessModelContainer'
import { ProcessmodelContainerTypeGuard } from './ProcessModelContainer/ProcessModelContainer.types'
import SaFChartFilter from './SaFChartFilter/SaFChartFilter'
import { SupportBannerContainerTypeGuard } from './SupportBannerContainer/SupportBannerContainer.types'
import { SupportBannerSecondaryContainerTypeGuard } from './SupportBannerSecondaryContainer/SupportBannerSecondaryContainer.types'
import { TabsContentTypeGuard } from './TabsContent/TabsContent.types'
import { TaskExecutorTypeGuard } from './TaskExecutor/TaskExecutor.types'
import { TextExpressionContainerTypeGuard } from './TextExpressionContainer/TextExpressionContainer.types'
import { TextSliderTypeGuard } from './TextSlider/TextSlider.types'
import { TopLineTypeGuard } from './TopLine/TopLine.types'
import { WorkflowmodelContainerTypeGuard } from './WorkflowmodelContainer/WorkflowmodelContainer.types'

export type ComponentsPathsOptions = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: React.FC<{ props: any }>
}

export type ComponentsTypeGuard = {
  [key: string]: ComponentTypeGuard
}

export const componentsPaths: ComponentsPathsOptions = {
  SupportArea: Area,
  FilterArea: Area,
  DataArea: Area,
  ObjectArea: Area,
  TopLine,
  FilterFields,
  DataTables,
  SaFChartFilter,
  ObjectView,
  DataCards,
  SupportBannerSecondary,
  DynamicTextHighlight,
  SiteFooter,
  HeroBanner,
  Article,
  NavigationSliderSecondary,
  DynamicInfoCardHighlight,
  SupportBanner,
  HeroBannerSecondary,
  Cards,
  Workflowmodel,
  Kanban,
  TextExpression,
  DataMap,
  Cockpit,
  Authentication,
  Unauthorized,
  AccessRestriction,
  CardCarousel,
  SummaryDetailsCarousel,
  PartnerCard,
  Accordion,
  EventCard,
  ArticlesList,
  TabsContent,
  Grid,
  Row,
  Col,
  ElementRenderer,
  Metadata,
  ActionSteps,
  Separator,
  NumericCardList,
  FilterableMap,
  AnimationSlider,
  ActionButton,
  DynamicInfoCardHighlightSimplified,
  Divider,
  ContextualNavigationSlider,
  TextSlider,
  TaskExecutor,
  Processmodel,
  Video
}

export const componentsTypeGuard: ComponentsTypeGuard = {
  HeroBanner: HeroBannerContainerTypeGuard,
  HeroBannerSecondary: HeroBannerSecondaryContainerTypeGuard,
  NavigationSliderSecondary: NavigationSliderSecondaryContainerTypeGuard,
  DynamicTextHighlight: DynamicTextHighlightContainerTypeGuard,
  Article: ArticleContainerTypeGuard,
  SupportBanner: SupportBannerContainerTypeGuard,
  SupportBannerSecondary: SupportBannerSecondaryContainerTypeGuard,
  Card: CardContainerTypeGuard,
  Workflowmodel: WorkflowmodelContainerTypeGuard,
  FilterFields: FilterFieldsTypeGuard,
  DataCards: DataCardsTypeGuard,
  TopLine: TopLineTypeGuard,
  DataTables: DataTablesTypeGuard,
  Kanban: KanbanTypeGuard,
  TextExpression: TextExpressionContainerTypeGuard,
  Authentication: AuthenticationTypeGuard,
  Accordion: AccordionTypeGuard,
  TabsContent: TabsContentTypeGuard,
  ActionSteps: ActionStepsTypeGuard,
  NumericCardList: NumericCardListTypeGuard,
  AnimationSlider: AnimationSliderContainerTypeGuard,
  ActionButton: ActionButtonTypeGuard,
  Divider: DividerTypeGuard,
  TextSlider: TextSliderTypeGuard,
  TaskExecutor: TaskExecutorTypeGuard,
  Processmodel: ProcessmodelContainerTypeGuard
}
